import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { getDrivers } from "../../../actions/driver/driver";
import OperatorListComponent from "../../../components/Definition/Operator/OperatorListComponent";
import { deleteOperator, getOperators } from "../../../actions/operators/operators";
import { deleteEquipment } from "../../../actions/equipments/equipments";

export default function OperatorsScreen() {
    const [operators, setOperators] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();


    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getOperators(params.toString());
                setLoading(false);
                setOperators(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <OperatorListComponent lists={operators} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید اپراتور حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteOperator(id);
                    if (response.status === "success") {
                        toast.success("اپراتور حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف اپراتور!");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
